<div class="col-12 d-flex  content-layout">
    <!-- <div class="d-flex flex-column" style="width: 110px;z-index: 2;">
        <div class="child-content-layout">
            <app-sidebar></app-sidebar>
        </div>
    </div> -->
    <div class="col-12 d-flex flex-column align-items-center child-content-layout2">
        <div class="col-12">
            <app-topbar></app-topbar>
        </div>
        <div class="col-12 child-content-body d-flex justify-content-center">
            <div class="col-11">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>